<template lang="pug">
    div.v-fragment
        div.chapter.chapter-intro.block-1(data-navbar-uncolored)
            div.container.has-text-white.has-text-centered
                h2.is-size-7.is-uppercase.has-letter-spacing  {{ $t('page_03_05.block_1.subtitle') }}
                h1.is-size-32.is-uppercase.has-text-weight-light.has-line-height(v-html="$t('page_03_05.block_1.title')")

        div.chapter.chapter-period.block-2
            div.container
                div.columns
                    div.column.is-2.is-hidden-mobile
                        img.is-block.is-fullw.animated.slow.chapter-period-fadein(src="../assets/images/05_Equipa/equipa-2.jpg", data-animate="fadeInUp")
                    div.column.is-4.is-offset-6.has-text-centered-mobile.chapter-period-text
                        h1.is-size-7.is-uppercase.has-letter-spacing {{ $t('page_03_05.block_2.title') }}
                        p {{ $t('page_03_05.block_2.text') }}

                div.columns.is-up-1
                    div.column.is-5.is-offset-1
                        img.is-block.is-fullw.animated.slow.chapter-period-fadein(src="../assets/images/05_Equipa/equipa-3.jpg", data-animate="fadeInUp")

                div.columns.is-up-2.is-hidden-mobile
                    div.column.is-offset-2
                        h2.is-size-80.has-text-grey-light.is-uppercase.has-letter-spacing.is-marginless.animated.chapter-period-fadein(data-animate="fadeInUp") {{ $t('page_03_05.block_2.word') }}

        div.chapter.chapter-banner.has-image-01.is-hidden-mobile(data-animate="zoom-in" data-navbar-uncolored)

        div.chapter.chapter-period.block-3
            div.container
                div.columns
                    div.column.is-7.has-text-centered-mobile.chapter-period-text
                        h1.is-size-7.is-uppercase.has-letter-spacing {{ $t('page_03_05.block_3.title') }}
                        p {{ $t('page_03_05.block_3.text') }}
                    div.column.is-3.is-offset-2.is-hidden-mobile
                        img.is-block.is-fullw.animated.slow.chapter-period-fadein(src="../assets/images/05_Equipa/equipa-6.jpg", data-animate="fadeInUp")

                div.columns.is-up-1
                    div.column.is-4.is-offset-6
                        img.is-block.is-fullw.animated.slow.chapter-period-fadein(src="../assets/images/05_Equipa/equipa-5.jpg", data-animate="fadeInUp")

                div.columns.is-up-2.is-hidden-mobile
                    div.column.is-offset-5
                        h2.is-size-80.has-text-grey-light.is-uppercase.has-letter-spacing.is-marginless.animated.chapter-period-fadein(data-animate="fadeInUp") {{ $t('page_03_05.block_3.word') }}

        div.chapter.chapter-banner.has-image-02(data-animate="zoom-in" data-navbar-uncolored)
</template>

<script>
export default {
    name: 'casa-relvas-team'
}
</script>

<style lang="stylus" scoped>

.has-image-01
    background-image url("../assets/images/05_Equipa/equipa-4.jpg")

.has-image-02
    background-image url("../assets/images/05_Equipa/equipa-7.jpg")

.block-1
    background-image url("../assets/images/05_Equipa/Equipa-1.jpg")

    @media screen and (max-width: 768px)
        background-image url("../assets/images/05_Equipa/5_Equipa-mobile.jpg")

.block-2
    @media screen and (min-width 1025px)
        margin-top 5rem
        .is-up-1
            margin-top -22%
            .column
                z-index -1
        .is-up-2
            margin-top -5.5%

.block-3
    @media screen and (min-width 1025px)
        margin-top 5rem
        .is-up-1
            margin-top -22%
        .is-up-2
            margin-top -6%

</style>
